import ClientModel from '@/models/client-model';
import ClientUnitModel from '@/models/client-unit-model';
import { IdCodNomeDTO, IdNomeDTO } from './base-dto';

export default interface IClientUnit {
  id: string;
  nome: string;
  areaGeografica: IdNomeDTO;
  cnpj?: string;
  imagem?: string;
  cliente: ClientModel;
  convenios?: any[];
  setores?: ISetor[];
  templates?: IdCodNomeDTO[];
  unidadesEmpresariais?: any[];
  produtos?: any[];
  enderecos?: IAddress[];
  ativo?: boolean;
  validarPrescricao?: boolean;
  usoBolsaMulticompart?: any;
  minBolsaMulticompart?: number;
  maxBolsaMulticompart?: number;
  diasAntecedProdBolsaMulti?: number;
  diasAntecedEntrBolsaMulti?: number;
  diasEntregaBolsaMulticompart?: string[];
  empresa: string;
  rotasEntrega?: any[];
  usoObservacaoPrescricao?: boolean;
  usoTerapia: boolean;
  terapias: IdNomeDTO[];
  produtosEnterais: IdNomeDTO[];
  enteralTipoCalculo: IdNomeDTO;
  viaFaturamento: IdNomeDTO;
  agendamentoProducao: boolean;
  horaAgendamentoProducao: string;
  pendenciaPrescWhatsappAutoMinutos: number;
  pendenciaPrescWhatsappTolerPrazo: number;
  usoPropostaFrete: boolean;
  campoRegistroObrigatorio: boolean;
  registroValidacaoRegexp: string;
  registroValidacaoExplic: string;
}

export interface IAddress {
  id?: string;
  codigo?: string;
  descricao?: string;
  logradouro: string;
  cep: string;
  bairro: string;
  municipio: string;
  estado: string;
  unidade?: IClientUnit;
  ativo?: boolean;
}

export interface ISetor {
  id: number;
  nome: string;
}

export class UnidadesFilterDTO {
  ativo: boolean;
  idCliente: number;
  termos: string;
}

export class UnidadeParmDTO {

  id: number;
  ativo: boolean;
  validarPrescricao: boolean;
  usoObservacaoPrescricao: boolean;
  viaFaturamento: string;
  agendamentoProducao: boolean;
  horaAgendamentoProducao: string;
  pendenciaPrescWhatsappAutoMinutos: number;
  pendenciaPrescWhatsappTolerPrazo: number;

  usoBolsaMulticompart: string;
  minBolsaMulticompart: number;
  maxBolsaMulticompart: number;
  diasAntecedProdBolsaMulti: number;
  diasAntecedEntrBolsaMulti: number;
  diasEntregaBolsaMulticompart: string[];

  usoTerapia: boolean;
  idsTerapias: number[];
  idsProdutosEnterais: number[];
  enteralTipoCalculo: string;
  idsProdutos: number[];
  idsConvenios: number[];
  setores: any[];
  idsTemplates: number[];
  usoPropostaFrete: boolean;
  campoRegistroObrigatorio: boolean;
  registroValidacaoRegexp: string;
  registroValidacaoExplic: string;

  constructor(unit: ClientUnitModel) {
    this.id = Number(unit.id);
    this.ativo = unit.ativo;
    this.validarPrescricao = unit.validarPrescricao;
    this.usoObservacaoPrescricao = unit.usoObservacaoPrescricao
    this.viaFaturamento = unit.viaFaturamento ? unit.viaFaturamento.id : null;
    this.agendamentoProducao = unit.agendamentoProducao ? unit.agendamentoProducao.id : null;
    this.horaAgendamentoProducao = unit.horaAgendamentoProducao;
    this.pendenciaPrescWhatsappAutoMinutos = unit.pendenciaPrescWhatsappAutoMinutos;
    this.pendenciaPrescWhatsappTolerPrazo = unit.pendenciaPrescWhatsappTolerPrazo;
    
    this.usoBolsaMulticompart = unit.usoBolsaMulticompart ? unit.usoBolsaMulticompart.id : null;
    this.minBolsaMulticompart = unit.minBolsaMulticompart;
    this.maxBolsaMulticompart = unit.maxBolsaMulticompart;
    this.diasAntecedProdBolsaMulti = unit.diasAntecedProdBolsaMulti;
    this.diasAntecedEntrBolsaMulti = unit.diasAntecedEntrBolsaMulti;
    this.diasEntregaBolsaMulticompart = unit.diasEntregaBolsaMulticompart;

    this.usoTerapia = unit.usoTerapia;
    this.idsTerapias = unit.terapias ? unit.terapias.map(t => Number(t.id)) : [];
    this.idsProdutosEnterais = unit.produtosEnterais ? unit.produtosEnterais.map(p => Number(p.id)) : [];
    this.enteralTipoCalculo = unit.enteralTipoCalculo ? unit.enteralTipoCalculo.id : null;
    this.idsProdutos =  unit.produtos ? unit.produtos.map(p => Number(p.id)) : [];
    this.idsConvenios =  unit.convenios ? unit.convenios.map(c => Number(c.id)) : [];
    this.setores =  unit.setores ? unit.setores.map(s => {
      if (s.new) {
        s.id = null
      };
      return s;
    }) : [];
    this.idsTemplates =  unit.templates ? unit.templates.map(t => Number(t.id)) : [];
    this.usoPropostaFrete = unit.usoPropostaFrete;
    this.campoRegistroObrigatorio = unit.campoRegistroObrigatorio;
    this.registroValidacaoRegexp = unit.registroValidacaoRegexp;
    this.registroValidacaoExplic = unit.registroValidacaoExplic;
  }

}